import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { Feeds } from "./Feeds";
import "./Feedback.css";
import api from "../../utils/api";
import { Box, Typography } from "@mui/material";

export const Feedback = () => {
  const [question, setQ] = useState({});
  const [answer, setAnswer] = useState("");
  const [error, setError] = useState("");
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;

  const submitAnswer = (e) => {
    e.preventDefault();

    if (!answer) {
      setError("required");
    } else if (answer.length < 50) {
      setError("your answer should be 50 chrachters long atleast.");
    } else {
      console.log("question", question);
      console.log("answer", answer);
      const body = {
        userId: currentUser.id,
        user: currentUser,
        questionId: question?._id,
        question: question,
        answer: answer,
      };
      api
        .post("/questions/answer", body)
        .then((res) => {
          if (res.data) {
            let notifBody = {
              userId: currentUser?.id,
              text: `${currentUser?.name} answers your question.`,
              forAll: false,
              receiverId: question?.userId,
            };
            api
              .post("/notifications", notifBody)
              .then((re) => console.log("notif", re.data));
            window.location.reload();
          }
        })
        .catch((err) => console.log(err));
    }
  };
  return (
    <Box>
      {/* <Header />
      <Menunav /> */}
      <Box className="row">
        {/* <Box className="col-md-2 col-0">
          <Sidebar />
        </Box> */}
        <Box className=" col-12">
          <Feeds setQ={setQ} />
        </Box>
      </Box>

      <Box
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <Box className="modal-dialog answer__question__modal">
          <Box className="modal-content answer__question__modal">
            <Box className="modal-header">
              <Typography
                variant="h5"
                className="modal-title"
                id="exampleModalLabel"
              >
                Write your answer
              </Typography>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </Box>

            <Box className="form ">
              <Box>
                <Box className="modal-body ">
                  <textarea
                    className="form-control input__field__asc"
                    name="comment"
                    id="comment"
                    placeholder="Comment"
                    onChange={(e) => setAnswer(e.target.value)}
                  />
                  {error && <p className="error__para">{error}</p>}
                </Box>

                <Box className="modal-footer">
                  <button
                    className="asc__submit__form__button btn-primary"
                    onClick={(e) => submitAnswer(e)}
                  >
                    Submit Answer
                  </button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default Feedback;
